import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Scrollbar } from 'react-scrollbars-custom';
import { StyledPdfWrapper } from '../reports/debtList/PdfWrapper.styled';
import { StyledCharges } from './CollectionStatus.styled';
import DepositCard from './DepositCard';
import ColectionPdfRow from './ColectionPdfRow';

const BankDeposit = ({ records, container, csvCallback, pdfDepositContainer, address, client, buildingID }) => {
    const { t } = useTranslation();

    const ltr = useSelector(state => state.common.ltrEnabled);

    const renderRecords = (record, i) => {
        return (
            <DepositCard 
                key={i} 
                record={record}
                csvCallback={csvCallback}
                client={client}
                buildingID={buildingID}
                isBankDeposit
            />
        )
    };

    const renderPdfRows = (record, i) => <ColectionPdfRow record={record} key={i} />;

    return (
        <StyledCharges ltr={ltr}>
            {records?.length === 0 && <div className='no_records'>{t('expenses.bank_adjustments.no_records')}</div>}
            {records?.length > 0 && (
                <div className='records-wrapper'>
                    <div>
                        <div className='outside-headers deposit'>
                            <div>{t('reports.expenses_deposit_date')}</div>
                            <div>{t('reports.amount')}</div>
                            <div>{t('reports.apt_num')}</div>
                            <div>{t('reports.tenantName')}</div>
                            <div>{t('reports.paid_for')}</div>
                            <div>{t('expenses.payment_type')}</div>
                            <div>{t('expenses.status')}</div>
                        </div>

                        <div className='records-cards-wrapper'>
                            {records?.map((record, i) => renderRecords(record, i))}
                        </div>
                    </div>

                </div>
            )}  
                 
            <div id="section-to-print" ref={container}>
                {pdfDepositContainer && (
                    <StyledPdfWrapper ltr={ltr}>
                        <div className='pdf-title'>{t('reports.bank_deposit')} <span>{address}</span></div>

                        <div className='pdf-rows-wrapper'>
                            <div className='pdf-row'>
                                <div className='expenses'>{t('reports.expenses_deposit_date')}</div>
                                <div className='expenses'>{t('reports.amount')}</div>
                                <div className='expenses'>{t('reports.apt_num')}</div>
                                <div className='expenses'>{t('reports.tenantName')}</div>
                                <div className='expenses'>{t('reports.paid_for')}</div>
                                <div className='expenses'>{t('expenses.payment_type')}</div>
                                <div className='expenses'>{t('expenses.status')}</div>
                            </div>

                            {records?.map((record, i) => renderPdfRows(record, i))}
                        </div>
                    </StyledPdfWrapper>
                )}
            </div>
        </StyledCharges>
    )
}

export default BankDeposit;
